import { isMobile } from 'utils/platform';

const platform = isMobile() ? 'mobile' : 'desktop';

export default platform;
